<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="items"
    :server-items-length="meta.total"
    :footer-props="footerProps"
    :options="options"
    :page="page"
    :items-per-page="itemsPerPage"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    :multi-sort="multiSort"
    v-on="listeners"
  >
    <template v-slot:item.has_notruf="{ item }">
      <v-checkbox v-model="item.has_notruf" disabled></v-checkbox>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip :color="item.status_color" text-color="white">
        {{ item.status }}
      </v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';

export default {
  name: 'BuildingList',

  mixins: [i18nRefreshData, listItems],

  data: () => ({}),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER_NAME'),
          value: 'business_customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex'
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'street'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'city'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          value: 'management_company'
        },
        {
          text: this.$t('BUILDINGS.NOTRUF_INCL'),
          value: 'has_notruf'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.CONCIERGE'),
          value: 'concierge'
        },
        {
          text: this.$t('APARTMENTS.ITEMS'),
          value: 'apartments_count'
        },
        {
          text: this.$t('BUILDINGS.INHABITANTS'),
          value: 'inhabitants_count'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  }
};
</script>
